import { atom } from 'nanostores'

import type { BlockedReason } from '~/features/billing/types'

export const $billingBlockedDialog = atom<{ open: boolean; reason: BlockedReason | null }>({
  open: false,
  reason: null
})

export const openBillingBlockedDialog = (reason?: BlockedReason | null) =>
  $billingBlockedDialog.set({ open: true, reason: reason ?? null })

export const closeBillingBlockedDialog = () => $billingBlockedDialog.set({ open: false, reason: null })

/** Set while a completed checkout waits for the new plan to land. */
export const $checkoutSyncing = atom<boolean>(false)
